import HttpService from './Http.service';

export default class CategoriaService extends HttpService {
  async listarTodos() {
    const res = await this.request('categorias');
    const categorias = await res.json();
    return categorias;
  }
}
